import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://28b29de35cace97398a737806a123cf3@o1317061.ingest.us.sentry.io/4507576510906368',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 0.1,
  tracePropagationTargets: [],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
